<script>
    import {
        ItemInserir,
        Tipo,
        generateCreateTableSQL,
    } from "../../Classes/ItemInserir";
    import { Paper, Accordion, Button, Title } from "@svelteuidev/core";
    import Constantes from "../../Classes/Constantes";
    import ValidacaoForm from "../../Classes/ValidacaoForm";
    import InserirDadosAcordion from "../../Componentes/InsercaoDados/InserirDadosAcordion.svelte";
    import { onMount } from "svelte";
    import Conexoes from "../../Classes/Conexoes";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import Loading from "../../componentes_basicos/Loading.svelte";
    //import DropSelecao from "../../componentes_basicos/DropSelecao.svelte";
    import DropSelecao from "../../componentes_basicos/DropSelecaoCor.svelte";
    import DatePickerSelecao  from "../../componentes_basicos/DatePickerSelecao.svelte";
    import AccordionItem from "../../componentes_basicos/AccordionItem.svelte";
    import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
    import CaixaDeDialogo2 from "../../componentes_basicos/CaixaDeDialogo.svelte";
    import { DadosLogin } from "../../Classes/Stores";
    import TelasAcessoNaoAutorizado from "./TelasAcessoNaoAutorizado.svelte";
    import { logado } from "../../Classes/EstadoLogado";
let mensagem2 = "";
    let conexao = new Conexoes();
    export let id_assessoria = $DadosLogin.id_assessoria;
    let isLoading = false;
    let resultados = {
        datas: "",
        usuarios: "",
        treinos: "",
    };
    let itens = [resultados];
    let datasSelecionadas = [];
    let message;
    function AdicionaItens() {
        let resultado = {
            datas: "",
            usuarios: "",
            treinos: "",
        };

        itens = [...itens, resultado];
    }

    function DeletaItem(index) {
        itens.splice(index, 1);
        itens = [...itens];
    }

    async function PrescreverTreinos() { 
        const valida = new ValidacaoForm();
        const prescricao = itens.map((item) => ({
            data: item.datas,
            usuario: item.usuarios,
            
            
        }));
        message = valida.valida(
            prescricao,
            ["data", "usuario"],
            ["Data ", "Usuário "],
        );
        if (!message) {
            isLoading = true;
            const jsonPrescricao = JSON.stringify(prescricao, null, 2);
            console.log(jsonPrescricao); 
            console.log(prescricao); 

            datasSelecionadas = prescricao.map((item) => item.data);
          
            let result = await conexao.conecta(
                "insere_plano_corrida2.php",
                { body: prescricao,id_assessoria:id_assessoria },
                
            );
            if (result.sucesso) {
                mensagem2 = "Treinos prescritos com sucesso!";
            } else {
                message = "Erro ao prescrever treinos!";
            }
            isLoading = false;
        }
    }

    let config_selecao_usuario = {
        api: Constantes.api_consultar_padrao,
        query_code: "consulta_usuarios_assessorias_ativado_qtd_prescricao",
        campos_pesquisaveis: ["nome_usuario", "meta"],
        colunas_exibidas: ["nome_usuario", "meta"],
        coluna_saida: "id",
        titulo: "Selecione os usuários",
        parametro_adicional: id_assessoria,
    };

   

    onMount(async () => {});

    function Resultado(e) {}

    function Refresh(){
        window.location.reload();
    }
</script>

<CaixaDeDialogo {message} on:close={(message = "")} />
<CaixaDeDialogo2 message={mensagem2} on:close={()=>{(message = "")
    mensagem2 = ""}} 
    button1Action = {Refresh} />
<LoadingTela {isLoading} />

{#if $DadosLogin.id_assessoria && $DadosLogin.id_assessoria > 0 }
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <Accordion
                    multiple
                    chevronPosition="left"
                    variant="separated"
                    defaultValue={"Item " + 1}
                >
                    {#each itens as item, j}
                        <Accordion.Item value={"Item " + (j + 1)}>
                            <div slot="control">
                                <Title order={4} color="gray"
                                    >{"Item " + (j + 1)}</Title
                                >
                            </div>
                            <h5>Montar a planilha</h5>
                            <DatePickerSelecao bind:saida={item.datas} />
                            <br />
                            <h5>Usuários</h5>
                            <DropSelecao
                                config={config_selecao_usuario}
                                bind:saida={item.usuarios}
                            />
                            
                           
                            <br />
                            <div class="d-flex justify-content-end">
                                <a
                                    href="#"
                                    class="btn btn-link"
                                    on:click={() => DeletaItem(j)}
                                    >Deleta item</a
                                >
                            </div>
                        </Accordion.Item>
                    {/each}
                    <br />
                    <div class="d-flex justify-content-between">
                        <Button color="gray" variant="outline" on:click={AdicionaItens}
                            >Adiciona mais item</Button
                        >
                    </div>
                    <br />

                    <Button color="gray" fullSize on:click={PrescreverTreinos}
                        >Salvar Treinos</Button
                    >
                </Accordion>
            </div>

            <div class="col-md-6 d-none d-md-block">
                <div class="card-container"></div>
            </div>
        </div>
    </div>
{:else}
    <TelasAcessoNaoAutorizado />
{/if}

<style>
    .padraoAviso {
        background-color: #d6eaf8;
        text-align: center;
    }
    .container {
        max-width: 1280px;
        margin: 50px auto;
        padding: 1rem;
        background-color: #e6e8f3;
    }

    .card-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100vh; /* Ocupa toda a altura da tela */
    }

    .card {
        width: 300px;
        text-align: center;
    }
    .imagem {
        max-width: 100%;
    }
    textarea#regulamento {
        height: 150px;
        overflow-y: auto;
    }
    .add-remove-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;
    }

    .rounded-circle {
        width: 40px;
        height: 40px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        border: 1px solid #dee2e6; /* Contorno sombreado leve */
        margin: 10px;
    }

    .rounded-circle:hover {
        background-color: #f8f9fa; /* Altera a cor de fundo ao passar o mouse */
    }

    /* Estilo para datas selecionadas em cinza */
    .svelte-calendar__day--selected {
        background-color: grey;
        color: white;
    }
</style>
